import React from "react";

/**
 * Fallback Suspense delle route — mai un muro sul touch:
 * - `pointer-events: none` permanente (nessun layer blocca lo schermo);
 * - fade automatico a 1.2s via CSS (`.route-loader` in mobile-layout.css):
 *   se un chunk lazy ritarda, il loader sparisce invece di restare fisso;
 * - se il chunk fallisce del tutto interviene AppErrorBoundary
 *   (auto-reload una volta su ChunkLoadError, poi schermata con «Ricarica»).
 */
export default function RouteLoader() {
  return (
    <div className="route-loader" role="status" aria-live="polite" data-testid="route-loader">
      <span className="route-loader__spinner" aria-hidden="true" />
      <span className="route-loader__label font-display">Caricamento…</span>
    </div>
  );
}
